export default __webpack_public_path__ + "media/assets/fonts/roboto-slab-v13-latin-regular-b5ae5d4f32ffbdec959b3da7e048c5da.eot";